import React, { useImperativeHandle } from "react";
import { useRequest, useUpdateEffect } from "ahooks";
import { useGlobalState } from "@/GlobalProvider";
import { useTranslation } from "@/langs/useTranslation";
import { getAlarmTemplateCreatorsApi } from "@/apis/apiCollection";
import SingleSelector from "../SingleSelector";

const AlarmTemplateCreators = React.forwardRef(
  ({ disabled, name, value, onChange }, ref) => {
    const { t } = useTranslation();
    const { currentCompanyId } = useGlobalState();
    const { data = { data: [] }, run } = useRequest(
      getAlarmTemplateCreatorsApi
    );

    useUpdateEffect(run, [currentCompanyId]);

    useImperativeHandle(ref, () => ({
      getOptions: () => data.data
    }));

    return (
      <SingleSelector
        placeholder={t({ defaultMessage: "选择创建人" })}
        options={data.data}
        clearable
        disabled={disabled}
        name={name}
        value={value}
        onChange={onChange}
      />
    );
  }
);

export default AlarmTemplateCreators;
